import { ReactNode, useMemo, useState } from 'react';
import { useSuppressedFilter } from '../../state/FilterContext';
import { services } from '../../globals';
import { useSiteContext } from '../../state/SiteContext';
import { TextExtractor, findFirstComponentOfType } from '../internal/TextExtractor';

interface MarkdownExportLinkProps {
  children: ReactNode,
  suppress?: string,
  target?: string,
}

/***
 * A component that renders a link to the markdown export endpoint for a file path.
 */
export function MarkdownExportLink({ children, suppress, target }: MarkdownExportLinkProps): React.ReactElement {
  const linkedState = useSuppressedFilter(suppress || "");
  const { siteState } = useSiteContext();

  const [toValue, setToValue] = useState("");
  const toChild = useMemo(() => findFirstComponentOfType(children, "arg-to"), [children]);
  const linkDisplay = useMemo(() => findFirstComponentOfType(children, "arg-display"), [children]);

  const link = services.file.getDirectLink(
    siteState.site?.name || "",
    toValue,
    linkedState.validity || "",
    linkedState.systemProperties || {},
    linkedState.lang || "",
    "markdown",
  ) || "";
  return <>
    {toChild && (
      <TextExtractor onExtractedText={setToValue}>
        {toChild?.props.children}
      </TextExtractor>
    )}
    <a href={link} target={target}>{linkDisplay?.props.children || children}</a>
  </>;
}
